import {panel, clearfix, absCenter, absCenterY, colors} from '@xpertdox_js/xdstyle';

export default {
  container: {
    background: '#fff',
    minHeight: '100%',
    paddingBottom: '50vh',
  },
  editPanel: {
    padding: 0,
    width: '100%',
    fontSize: '1.2rem',
    minHeight: '100%',
    // overflow: 'hidden'
  },
  loaderContainer: {
    position: 'relative',
    width: '100%',
    height: '200px',
  }
}
